import { FC } from "react";

import LocalImages from "assets/images/local-images";
import ButtonText from "features/shared/components/buttons/submit-button/styles/ButtonText.styled";
import { useAppStore } from "store/store";

import FileItem from "./styles/FileItem";
import FilesContainer from "./styles/FilesContainer";

interface FilesListProps {
  files: File[];
  removeFileFromList: (index: number) => void;
}

const FilesList: FC<FilesListProps> = ({ files, removeFileFromList }) => {
  useAppStore((state) => state.locale);

  if (files.length === 0) {
    return null;
  }

  return (
    <FilesContainer>
      {files.map((file, index) => (
        <div key={`file-${index}`}>
          <FileItem>
            <ButtonText>{file.name}</ButtonText>
            <button onClick={() => removeFileFromList(index)}>
              <img
                alt="remove file from list icon"
                src={LocalImages.shared.images.icons.removeFileFromList}
              />
            </button>
          </FileItem>
        </div>
      ))}
    </FilesContainer>
  );
};
export default FilesList;
